import { useQuery } from "@tanstack/react-query";
import api_public from "../services/newApi/api_public";
import { queryKeys } from "../lib/queryKeys";

export const useFeatureFlag = (key: string) => {
  const { data, isLoading } = useQuery({
    queryKey: queryKeys.featureFlags.public(key),
    queryFn: async () => {
      const response = await api_public.get<{
        status: string;
        data: { key: string; enabled: boolean };
      }>(`/feature-flags/${key}`);
      // react-query proíbe undefined como data; flag ausente/sem payload → null.
      return response.data?.data ?? null;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    enabled: isLoading ? false : (data?.enabled ?? false),
    loading: isLoading,
  };
};
